import { apiClient } from '@/api/api'

export const requestPasswordReset = (email: string) => {
  return apiClient.post('/auth/forgot-password', { email })
}

